export enum MeteoHomeTabs {
  HourByHour = 'heure-par-heure',
  ThirtySixHours = '36-heures',
  FifteenDays = '15-jours',
}
